import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { isAfter } from "date-fns";
import {
  isProgrammesHasListeProduit,
  isProgrammesHasRemboursement,
  isProgrammesHasRenouvellement,
} from "../../../helpers/programme";
import { useReduxSelector } from "../../../hooks/useGetAdherent";
import { getListeAdhesions } from "../../../redux/AdherentRedux";
import {
  getAssisteur,
  getListeProgramme,
  setAssisteur,
  setListeprogramme,
} from "../../../redux/ProgrammeRedux";
import Api, { IApi } from "../../../services/Api";
import { Programme } from "../../../services/Api/swagger";
import { getApiEndpoint } from "../../../services/Config";
import { ErrorApi } from "../../../types";

export const useProgrammes = () => {
  const [programmes, setProgrammes] = useState<
    (string | undefined)[] | undefined
  >();
  const listeAdhesions = useReduxSelector((state) => getListeAdhesions(state));
  const dispatch = useDispatch();
  useEffect(() => {
    if (listeAdhesions) {
      const pgms: (string | undefined)[] | undefined =
        listeAdhesions && listeAdhesions.map((adh) => adh.codeProgramme);
      const uniqProgrammes = pgms?.filter(
        (pgm, index) => pgms.indexOf(pgm) === index
      );
      setProgrammes(uniqProgrammes);
      dispatch(setListeprogramme(undefined));
    } else {
      setProgrammes(undefined);
    }
  }, [listeAdhesions]);

  const listeProgrammes: Programme[] | undefined = useReduxSelector((state) =>
    getListeProgramme(state)
  );
  const [fetchingProgramme, setFetchingProgramme] = useState<boolean>(false);
  const [errorProgramme, setErrorProgramme] = useState<ErrorApi>();

  // ASSISTEUR

  const [fetchingAssisteur, setFetchingAssisteur] = useState<boolean>(false);
  const [errorAssisteur, setErrorAssisteur] = useState<ErrorApi>();
  const infoAssisteur = useReduxSelector((state) => getAssisteur(state));

  useEffect(() => {
    if (programmes && !listeProgrammes) {
      const api: IApi = Api.create(getApiEndpoint() || "http://localhost:8090"); // récupération de l'url de l'api (intégration, recette, production... )
      programmes.forEach((pgm) => {
        setFetchingProgramme(true);
        pgm &&
          api["getProgrammeByCode"](pgm)
            .then((response: Programme) => {
              dispatch(setListeprogramme(response));
              setFetchingProgramme(false);

              // GET ASSISTEUR
              response.code &&
                api["getAssisteur"](response.code)
                  .then((responseAssisteur) => {
                    if (responseAssisteur.nom) {
                      dispatch(setAssisteur(responseAssisteur));
                      setFetchingAssisteur(false);
                    }
                  })
                  .catch(function (error) {
                    setFetchingAssisteur(false);
                    setErrorAssisteur(error);
                  });
            })
            .catch(function (error) {
              setFetchingProgramme(false);
              setErrorProgramme(error);
            });
      });
    }
  }, [programmes, listeAdhesions]);

  const hasServiceFidelisation =
    listeAdhesions &&
      listeAdhesions.find((adh) => adh && adh.hasFidelisation === true)
      ? true
      : false;
  const hasListeProduits =
    (listeProgrammes && isProgrammesHasListeProduit(listeProgrammes)) || false;

  const hasRemboursement =
    (listeProgrammes && isProgrammesHasRemboursement(listeProgrammes)) || false;

  const hasRemorquageDepannage =
    listeAdhesions &&
      listeAdhesions.find((adh) => adh && adh.remorquageDepannage === true)
      ? true
      : false;

  const hasRenouvellemement =
    (listeProgrammes && isProgrammesHasRenouvellement(listeProgrammes)) ||
    false;

  const hasResiliation =
    listeAdhesions &&
      listeAdhesions.find((adh) => adh && adh.dateEcheance && isAfter(new Date(adh.dateEcheance), new Date()))
      ? true
      : false;

  return {
    fetchingProgramme,
    errorProgramme,
    listeAdhesions,
    hasServiceFidelisation,
    hasListeProduits,
    hasRemboursement,
    hasRemorquageDepannage,
    hasRenouvellemement,
    hasResiliation,

    // ASSISTEUR

    infoAssisteur,
    fetchingAssisteur,
    errorAssisteur,
  };
};
